export default "__VITE_ASSET__Cj0eNIW4__"